export enum HttpStatusCodes {
	ok = 200,
	partialContent = 206,
	badRequest = 400,
	unauthorized = 401,
	forbidden = 403,
	notFound = 404,
	methodNotAllowed = 405,
	notAcceptable = 406,
	requestTimeout = 408,
	conflict = 409,
	preconditionFailed = 412,
	internalServerError = 500,
	notImplemented = 501,
	badGateway = 502,
	serviceUnavailable = 503,
}
